import type { IconData } from '@stacksjs/iconify-core'

export const squareFull: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 22H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M4 20h16V4H4Z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default squareFull
